export var fonts;
(function (fonts) {
    fonts["bold"] = "Universal Sans Bold";
    fonts["medium"] = "Universal Sans Medium";
    fonts["regular"] = "Universal Sans Regular";
    fonts["serif"] = "Financier Display";
})(fonts || (fonts = {}));
export const TYPOGRAPHY = {
    display1: {
        desktop: `
      font-size: 80px;
      line-height: 84px;
      letterSpacing: -0.02em;
      font-family: ${fonts.regular};
    `,
        mobile: `
      font-size: 56px;
      line-height: 64px;
      letter-spacing: -0.01em;
      font-family: ${fonts.regular};
    `,
    },
    display2: {
        desktop: `
      font-size: 64px;
      line-height: 68px;
      letterSpacing: -0.015em;
      font-family: ${fonts.regular};
    `,
        mobile: `
      font-size: 44px;
      line-height: 52px;
      letter-spacing: -0.005em;
      font-family: ${fonts.regular};
    `,
    },
    display3: {
        desktop: `
      font-size: 48px;
      line-height: 56px;
      letterSpacing: -0.01em;
      font-family: ${fonts.regular};
    `,
        mobile: `
      font-size: 36px;
      line-height: 44px;
      letter-spacing: -0.005em;
      font-family: ${fonts.regular};
    `,
    },
    displaySerif1: {
        desktop: `
      font-size: 96px;
      line-height: 100px;
      letterSpacing: -0.02em;
      font-family: ${fonts.serif};
    `,
        mobile: `
      font-size: 56px;
      line-height: 64px;
      letter-spacing: -0.01em;
      font-family: ${fonts.serif};
    `,
    },
    displaySerif2: {
        desktop: `
      font-size: 76px;
      line-height: 80px;
      letterSpacing: -0.015em;
      font-family: ${fonts.serif};
    `,
        mobile: `
      font-size: 44px;
      line-height: 52px;
      letter-spacing: -0.005em;
      font-family: ${fonts.serif};
    `,
    },
    displaySerif3: {
        desktop: `
      font-size: 60px;
      line-height: 68px;
      letterSpacing: -0.01em;
      font-family: ${fonts.serif};
    `,
        mobile: `
      font-size: 36px;
      line-height: 44px;
      letter-spacing: -0.005em;
      font-family: ${fonts.serif};
    `,
    },
    headline1: {
        desktop: `
      font-size: 28px;
      line-height: 36px;
      letter-spacing: -.005em;
      font-family: ${fonts.regular};
    `,
        mobile: `
      font-size: 28px;
      line-height: 36px;
      letter-spacing: -0.005em;
      font-family: ${fonts.regular};
    `,
    },
    headline2: {
        desktop: `
      font-size: 24px;
      line-height: 32px;
      font-family: ${fonts.regular};
    `,
        mobile: `
      font-size: 24px;
      line-height: 32px;
      letter-spacing: -0.01em;
      font-family: ${fonts.regular};
    `,
    },
    headline3: {
        desktop: `
      font-size: 20px;
      line-height: 28px;
      font-family: ${fonts.regular};
    `,
        mobile: `
      font-size: 20px;
      line-height: 28px;
      letter-spacing: -0.01em;
      font-family: ${fonts.regular};
    `,
    },
    label1: {
        desktop: `
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.005em;
      font-family: ${fonts.medium};
    `,
        mobile: `
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.005em;
      font-family: ${fonts.medium};
    `,
    },
    label2: {
        desktop: `
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.005em;
      font-family: ${fonts.medium};
    `,
        mobile: `
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.005em;
      font-family: ${fonts.medium};
    `,
    },
    label3: {
        desktop: `
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.005em;
      font-family: ${fonts.medium};
    `,
        mobile: `
      font-size: 12px;
      line-height: 16px;
      font-family: ${fonts.medium};
    `,
    },
    label4: {
        desktop: `
      font-size: 10px;
      line-height: 10px;
      letter-spacing: -0.005em;
      font-family: ${fonts.medium};
    `,
        mobile: `
      font-size: 10px;
      line-height: 10px;
      font-family: ${fonts.medium};
    `,
    },
    body1: {
        desktop: `
      font-size: 16px;
      line-height: 24px;
      font-family: ${fonts.regular};
    `,
        mobile: `
      font-size: 16px;
      line-height: 24px;
      font-family: ${fonts.regular};
    `,
    },
    body2: {
        desktop: `
      font-size: 14px;
      line-height: 22px;
      font-family: ${fonts.regular};
    `,
        mobile: `
      font-size: 14px;
      line-height: 22px;
      font-family: ${fonts.regular};
    `,
    },
    body3: {
        desktop: `
      font-size: 12px;
      line-height: 16px;
      font-family: ${fonts.regular};
    `,
        mobile: `
      font-size: 12px;
      line-height: 16px;
      font-family: ${fonts.regular};
    `,
    },
    overline: {
        desktop: `
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.01em;
      font-family: ${fonts.regular};
    `,
        mobile: `
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.01em;
      font-family: ${fonts.regular};
    `,
    },
};
//# sourceMappingURL=typography.js.map